/**
 * hasDuplicates 查看数组是否有重复项
 * @param array {array}
 * @returns {boolean}
 */
export function hasDuplicates(array) {
  return array.some((item, index) => {
    return array.indexOf(item) !== index
  })
}
